export default function RippleLoading(props) {
  return (
    <div className="ripple">
      <div className="container">
        <div className="lds-ripple">
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
}
